import React, { useContext } from 'react';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import { LatLngBoundsLiteral, icon } from 'leaflet';
import { Helmet } from 'react-helmet';
import {
  OfficesContext,
  OfficesContextType,
} from '../../../context/ProfileContext';
import { GlobalContext } from '../../../context/GlobalContext';
import greenMarker from '../../../images/marker-icon-green.png';
import { OfficeProfileViewType } from '../../../types/services-api';
import LoadingSpinner from '../../common/LoadingSpinner';

const OfficeMap = (props: { publicList?: OfficeProfileViewType[] }) => {
  const {
    userAuth: { isEmployer },
  } = useContext(GlobalContext);
  const { offices } = useContext(OfficesContext) as OfficesContextType;
  if (typeof window === 'undefined') {
    return null;
  } else if (isEmployer && offices.length === 0) {
    return <LoadingSpinner />;
  } else {
    const officeList = !!props.publicList ? props.publicList : offices;
    const bounds: LatLngBoundsLiteral | undefined =
      officeList.length > 0
        ? officeList.map((job) => {
            const lat = Number(job.lat);
            const lng = Number(job.lng);
            return [lat, lng];
          })
        : undefined;

    const greenIcon = icon({
      iconUrl: greenMarker,
      iconSize: [25, 40],
      iconAnchor: [12, 40],
    });
    return (
      <>
        <Helmet>
          <link rel="stylesheet" href="/styles/leaflet.css" />
        </Helmet>
        <MapContainer
          bounds={bounds}
          zoom={10}
          maxZoom={14}
          attributionControl={false}
          style={{ minHeight: '300px', height: '100%' }}
        >
          <TileLayer url="https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=90vTrAsedbmk6OtJ8S1a" />
          {officeList.map((office) => (
            <Marker
              key={office.id}
              position={[Number(office.lat), Number(office.lng)]}
              icon={greenIcon}
            />
          ))}
        </MapContainer>
      </>
    );
  }
};

export default OfficeMap;
